module.exports = __webpack_public_path__ + "img/logo_main_white_hp.6141ac4f.svg";